/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LogoutTimer from '../../utilities/LogoutTimer';

import { AbilityContext } from '../../utilities/Can';
import defineAbilities from '../../utilities/defineAbilities';

// Layout Related Components

let ability;

class PrintLayout extends Component {
  constructor(props) {
    super(props);

    const { user } = props;
    ability = defineAbilities(user);
  }

  render() {
    return (
      <>
        <LogoutTimer />

        <AbilityContext.Provider value={ability}>
          <div>
            <div className="main-content" style={{ padding: 0 }}>{this.props.children}</div>
          </div>
        </AbilityContext.Provider>
      </>
    );
  }
}

PrintLayout.propTypes = {
  children: PropTypes.any,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  ...state.Layout,
  user: state.Login.user,
});

export default connect(mapStateToProps, {

})(withRouter(PrintLayout));
